module.exports = __webpack_public_path__ + "img/瓜蒌.468c36c6.jpg";